import { Component, OnInit, Inject, Optional, SimpleChanges } from '@angular/core';
import { Notify, NotifyLinkType } from '../../../interfaces/Notify';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifyService } from '../../../services/notify.service';
import { take, first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { whichProtocol } from "../../../utils/utils";
import { PlatformConfigService } from '../../../components/platform-config/platform-config.service';
import { CustomAlertService } from '../../../components/view/page/custom-alert/custom-alert.service';
import { LoggedUser } from '../../../models/loggedUser.service';

@Component({
  selector: 'mm-notify-dialog',
  templateUrl: './notify-dialog.component.html',
  styleUrls: ['./notify-dialog.component.scss']
})
export class NotifyDialogComponent implements OnInit {
  notifications: Notify[];
  actual: Notify;
  index: number = 0;
  textButton: string;
  socketNotifications$: Subscription;
  type: string

  check = new UntypedFormControl();
  checked: boolean;
  blockCopy: any;
  customAlerts = []
  loggedUser: any = null;
  isGoldMedalNotification: boolean = false;
  isSilverMedalNotification: boolean = false;
  isBronzeMedalNotification: boolean = false;
  medalType: 'gold' | 'silver' | 'bronze' | null = null;

  constructor(
    public dialogRef: MatDialogRef<NotifyDialogComponent>,
    private _notifyService: NotifyService,
    private router: Router,
    private _platformConfig: PlatformConfigService,
    private _customAlertService: CustomAlertService,
    private _loggedUser: LoggedUser,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { notifications: Notify[] }
  ) { }

  ngOnInit() {

    this._platformConfig.getBlockCopy().subscribe({
      next: resp => this.blockCopy = resp.blockCopy,
      error: err => console.log({ blockCopyError: err })
    });

    // Obter dados do usuário logado
    this._loggedUser.subscribeUserChange$().subscribe(user => {
      this.loggedUser = user;
    });

    this.notifications = this.data.notifications;
    this.socketNotifications$ = this._notifyService.getSocketNotifys()
      .subscribe(notify => this.notifications.push(notify));

    if (this.notifications.length) {
      this.actual = this.notifications[0];
      if (this.actual) {
        this.checkIfMedalNotification();
        this.actualHtmplus(this.actual);
        this.actualText(this.actual)
      }
      if (this.actual && this.actual.notifyInteraction) {
        this.isRequired(this.actual.notifyInteraction.requiredInteractionChk)
      }
      this.index = 0;
    }

    this.changeValue()

  }

  changeValue() {
    this.check.valueChanges.subscribe(e => this.checked = e)
  }

  buttonEvent(actual) {

    if (actual.notifyInteraction.type == 'PAGE') {
      this._notifyService.registerInteraction(actual.id).pipe(take(1)).subscribe(() => { })
      window.open(`/hp/page/${actual.notifyInteraction.pageId}`)
    } else if (actual.notifyInteraction.type == 'LINK') {
      this._notifyService.registerInteraction(actual.id).pipe(take(1)).subscribe(() => { })
      let domain = '';
      if (actual.notifyInteraction?.url.startsWith('/')) {
        this.router.navigate([actual.notifyInteraction?.url]);
      } else if (actual.notifyInteraction.url.indexOf('http://') <= -1 && actual.notifyInteraction.url.indexOf('https://') <= -1) {
        domain = whichProtocol();
        window.open(`${domain}${actual.notifyInteraction.url}`);
      } else {
        window.open(`${actual.notifyInteraction.url}`);
      }

    }

    this.next();
  }

  next() {
    let type = this.actual.activity ? 'activities' : 'default'
    this._notifyService.viewNotify(this.actual.id, type).pipe(take(1)).subscribe(() => { });
    if (this.index < (this.notifications.length - 1)) {
      this.index++;
      this.actual = this.notifications[this.index];
      this.checkIfMedalNotification();
      this.actualHtmplus(this.actual);
      this.isRequired(this.actual.notifyInteraction.requiredInteractionChk);
      this.actualText(this.actual);
    } else {
      this.dialogRef.close();
    }
  }

  checkIfMedalNotification(): void {
    const title = this.actual?.title;
    this.isGoldMedalNotification = title === "Medalha de Ouro!";
    this.isSilverMedalNotification = title === "Medalha de Prata!";
    this.isBronzeMedalNotification = title === "Medalha de Bronze!";

    if (this.isGoldMedalNotification) {
      this.medalType = 'gold';
    } else if (this.isSilverMedalNotification) {
      this.medalType = 'silver';
    } else if (this.isBronzeMedalNotification) {
      this.medalType = 'bronze';
    } else {
      this.medalType = null;
    }
  }

  getUserInitials(fullName: string): string {
    if (!fullName) return '';
    const names = fullName.split(' ');
    if (names.length === 1) {
      return names[0].substring(0, 2).toUpperCase();
    }
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  }

  getMedalIcon(medalType: string): string {
    switch (medalType) {
      case 'gold':
        return 'fa-trophy';
      case 'silver':
        return 'fa-medal';
      case 'bronze':
        return 'fa-award';
      default:
        return 'fa-star';
    }
  }

  getMedalColor(medalType: string): string {
    switch (medalType) {
      case 'gold':
        return '#FFD700';
      case 'silver':
        return '#C0C0C0';
      case 'bronze':
        return '#CD7F32';
      default:
        return '#6B7280';
    }
  }

  getMedalText(medalType: string): string {
    switch (medalType) {
      case 'gold':
        return 'MEDALHA DE OURO';
      case 'silver':
        return 'MEDALHA DE PRATA';
      case 'bronze':
        return 'MEDALHA DE BRONZE';
      default:
        return 'MEDALHA';
    }
  }

  actualText(actual: Notify) {
    if (actual.notifyInteraction.type == 'PAGE') {
      this.textButton = actual.notifyInteraction.requiredInteractionPageBtnTxt ? actual.notifyInteraction.requiredInteractionPageBtnTxt : 'Submeter';
    } else if (actual.notifyInteraction.type == 'LINK') {
      this.textButton = actual.notifyInteraction.urlTitle ? actual.notifyInteraction.urlTitle : 'Submeter';
    }
    if (actual.notifyInteraction.requiredInteractionChk) {
      this.textButton = actual.notifyInteraction.requiredInteractionBtnChkTxt ? actual.notifyInteraction.requiredInteractionBtnChkTxt : 'Submeter';
    }
  }

  isRequired(required) {

    if (!required) {
      this.checked = true;
    } else {
      this.checked = false;
    }
  }


  actualHtmplus(actual) {
    if (!actual.htmlPlus) return;
  }


  close() {
    let type = this.actual.activity ? 'activities' : 'default'
    this._notifyService.viewNotify(this.actual.id, type).pipe(take(1)).subscribe(() => { });
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

    this.socketNotifications$ && this.socketNotifications$.unsubscribe();
  }
}
